<template>
	<o-tour
		:ref="setup._tourOrderStatus"
		:callback="() => setup.endTourCallback()">
		<o-tour-step
			title="Statut de la commande"
			size="md">
			<p>
				Cet onglet permet de voir l'avancement de la commande, et de suivre facilement le statut des différents candidats positionnés sur la commande.
			</p>
		</o-tour-step>
		<o-tour-step
			title="Avancement"
			target="order-details__stepper"
			size="lg">
			<p>
				Cette timeline donne une indication sur la progression de la commande.
				Il est ainsi plus facile d'anticiper les prochaines étapes liées à cette commande.
			</p>
			<ul>
				<li>L'état <strong>Traitement</strong> signifie qu'il n'y a pas encore assez d'intérimaires positionnés et validés pour la commande.</li>
				<br>
				<li>La commande est <strong>Pourvue</strong> lorsque le nombre d'intérimaires validés correspond au besoin de la commande.</li>

				<br>
				<li>La commande est <strong>Validée</strong> lorsque l'agence a validé manuellement la commande.</li>
				<br>
				<li>
					L'état <strong>Contrats liés</strong> correspond au moment où les contrats ont été édités.
					Vous pouvez les retrouver en cliquant sur cette étape.
				</li>
			</ul>
		</o-tour-step>
		<o-tour-step
			title="Candidats"
			target="candidates-status__container"
			size="md">
			<p>
				Dans cette section vous pouvez visualiser tous les candidats qui ont été positionnés.
			</p>
		</o-tour-step>
		<o-tour-step
			title="Aide"
			target="candidate-status-info"
			size="md"
			:next="setup.openHelpAside()">
			<p>
				Ce bouton d'aide vous permet d'afficher la légende concernant les différents statuts liés au profil d'un candidat.
			</p>
		</o-tour-step>
		<o-tour-step
			title="Aide"
			target="order-status-helper"
			size="md"
			:previous="setup.closeAside()">
			<p>
				Ce panneau vous permet de visualiser la légende correspondante aux différents statuts d'un sticker.
			</p>
		</o-tour-step>
		<o-tour-step
			title="Légende"
			target="order-details-status-helper-legend"
			size="md">
			<p>
				En cliquant sur un des éléments de la légende, vous pourrez voir plus en détail la signification des différents états.
			</p>
		</o-tour-step>
		<o-tour-step
			title="Sticker d'un candidat"
			target="candidate-sticker-helper"
			size="md">
			<p>
				Chaque candidat proposé pour cette commande sera représenté par un sticker avec différents statuts.
				<br>
				Ces statuts peuvent signifier plusieurs choses comme la disponibilité de l'intérimaire, si ses qualifications correspondent à la mission,
				s'il a fourni tous les documents ou même sa réponse à l'offre de mission.
			</p>
		</o-tour-step>
	</o-tour>
</template>

<script setup lang="ts">
import TourOrderStatusSetupService from '@/setup/tour/TourOrderStatusSetupService';
import { inject } from 'vue';
const _aside = inject<OrionAside>('_aside');
const setup = new TourOrderStatusSetupService(undefined, _aside);
</script>
